import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import HomeConsole from '@/views/HomeConsole.vue'
import Dashboard from '@/views/Dashboard.vue'
import DeviceManager from '@/views/DeviceManager.vue'
import ModelManager from '@/views/ModelManager.vue'
import ProductManager from '@/views/ProductManager.vue'
import ProductCategory from '@/views/ProductCategory.vue'
import OtaUpgrade from '@/views/OtaUpgrade.vue'
import ProtocolGateway from '@/views/ProtocolGateway.vue'
import ProtocolGatewayDetail from '@/views/ProtocolGatewayDetail.vue'
import ProtocolScript from '@/views/ProtocolScript.vue'
import ProductCategoryDetail from '@/views/ProductCategoryDetail.vue'
import LowcodePage from '@/views/LowcodePage.vue'
import UserManager from '@/views/UserManager.vue'
import FeedbackManager from '@/views/FeedbackManager.vue'
import SyncManager from '@/views/SyncManager.vue'
import DeptManager from '@/views/DeptManager.vue'
import RoleManager from '@/views/RoleManager.vue'
import ProjectManager from '@/views/ProjectManager.vue'
import ConfigManager from '@/views/ConfigManager.vue'
import OemConfig from '@/views/OemConfig.vue'
import AuthManager from '@/views/AuthManager.vue'
import TenantManager from '@/views/TenantManager.vue'
import TemplateConfig from '@/views/TemplateConfig.vue'
import SlotManager from '@/views/SlotManager.vue'
import LoginLog from '@/views/LoginLog.vue'
import OperationLog from '@/views/OperationLog.vue'
import LoginPage from '@/views/LoginPage.vue'

const routes: RouteRecordRaw[] = [
  { path: '/', name: 'home', component: HomeConsole },
  { path: '/login',  name: 'Login',  component: LoginPage , meta: { title: '登录' } },
  { path: '/network/overview', name: 'overview', component: Dashboard },
  { path: '/network/device-mgr', name: 'device-mgr', component: DeviceManager },
  { path: '/network/model', name: 'model', component: ModelManager },
  { path: '/network/product-mgr', name: 'product-mgr', component: ProductManager },
  { path: '/network/product-cat', name: 'product-cat', component: ProductCategory },
  { path: '/network/product-cat/:id', name: 'product-cat-detail', component: ProductCategoryDetail },
  { path: '/network/ota', name: 'ota', component: OtaUpgrade },
  { path: '/network/gateway', name: 'gateway', component: ProtocolGateway },
  { path: '/network/gateway/:code', name: 'gateway-detail', component: ProtocolGatewayDetail }, // 将 :id 修改为 :code
  { path: '/network/script', name: 'script', component: ProtocolScript },
  { path: '/lowcode', name: 'lowcode', component: LowcodePage },
  { path: '/system',
    name: 'SystemLayout',
    component: () => import('@/views/SystemLayout.vue'),
    children: [
      { 
        path: 'systemConfig/user-mgr',
        name: 'user-mgr',
        component: UserManager
      },
      { 
        path: 'systemConfig/feedback',
        name: 'feedback',
        component: FeedbackManager
      },
      { 
        path: 'systemConfig/sync',
        name: 'sync',
        component: SyncManager
      },
      { 
        path: 'systemConfig/dept',
        name: 'dept',
        component: DeptManager
      },
      { 
        path: 'systemConfig/role',
        name: 'role',
        component: RoleManager
      },
      { 
        path: 'systemConfig/project',
        name: 'project',
        component: ProjectManager
      },
      { 
        path: 'systemConfig/config',
        name: 'config',
        component: ConfigManager
      },
      { 
        path: 'systemConfig/oem-config',
        name: 'oem-config',
        component: OemConfig
      },
      { 
        path: 'systemConfig/auth',
        name: 'auth',
        component: AuthManager
      },
      {
        path: 'systemConfig/protocol',
        name: 'ProtocolManager',
        component: () => import('@/views/ProtocolManager.vue'),
        meta: {
          title: '协议管理',
          requiresAuth: true
        }
      },
      {
        path: 'notify/message',
        name: 'notify-message',
        component: () => import('@/views/MessageConfig.vue'),
      },
      {
        path: 'notify/channel',
        name: 'notify-channel',
        component: () => import('@/views/ChannelConfig.vue')
      },
      {
        path: '/system/notify/template',
        name: 'NotifyTemplate',
        component: TemplateConfig
      },
      { 
        path: 'notify/internal',
        name: 'notify-internal',
        component: () => import('@/views/InternalMessage.vue')
      },
      // 平台管理路由
      {
        path: 'platform/tenant',
        name: 'platform-tenant',
        component: TenantManager
      },
      {
        path: 'platform/app',
        name: 'platform-app',
        component: () => import('@/views/AppManager.vue')
      },
      {
        path: 'platform/auth',
        name: 'platform-auth',
        component: () => import('@/views/PlatformAuth.vue')
      },
      {
        path: 'platform/auth',
        name: 'platform-auth',
        component: () => import('@/views/PlatformAuth.vue')
      },
      {
        path: 'dev/slot',
        name: 'dev-slot',
        component: () => import('@/views/SlotManager.vue')
      },
      {
        path: 'dev/analysis',
        name: 'dev-analysis',
        component: () => import('@/views/DataAnalysis.vue')
      },
      {
        path: 'dev/task',
        name: 'dev-task',
        component: () => import('@/views/TaskManager.vue')
      },
      {
        path: 'log/login',
        name: 'log-login',
        component: LoginLog
      },
      {
        path: 'log/operation',
        name: 'log-operation',
        component: OperationLog
      },
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 添加全局前置守卫
router.beforeEach((to, from, next) => {
  // 检查用户是否已登录（这里需要根据你的实际登录状态判断逻辑来修改）
  const isAuthenticated = localStorage.getItem('token') // 或其他登录状态判断方式
  
  // 如果路由是登录页面，直接放行
  if (to.path === '/login') {
    next()
    return
  }
  
  // 如果未登录且访问的不是登录页面，重定向到登录页
  if (!isAuthenticated) {
    next('/login')
    return
  }
  
  // 已登录状态下放行
  next()
})

export default router